// extracted by mini-css-extract-plugin
module.exports = {"documentBlockLayer":"documentBlockLayer__tnP+T"};